import { Component } from './component';

export type TableColumn = string | { header: string; key: string };

export interface TableViewProps {
  columns: TableColumn[];
}

export class TableView extends Component {
  public el: HTMLTableElement;
  public head: HTMLTableSectionElement;
  public body: HTMLTableSectionElement;

  constructor(props: TableViewProps) {
    super();
    this.el = document.createElement('table');
    this.el.classList.add('interactive');

    this.head = document.createElement('thead');
    const headerRow = document.createElement('tr');

    for (const col of props.columns) {
      const th = document.createElement('th');
      if (typeof col === 'string') {
        th.innerText = col;
      } else {
        th.innerText = col.header;
      }
      headerRow.appendChild(th);
    }

    this.head.appendChild(headerRow);
    this.el.appendChild(this.head);

    this.body = document.createElement('tbody');
    this.el.appendChild(this.body);
  }
}
